import React from 'react';

const Roles = () => {
  return (
    <div>
      <h1>Role Management</h1>
      <p>Manage user roles and permissions - to be implemented</p>
    </div>
  );
};

export default Roles;
